import { CustomerSearchOptions, CustomerSearchPage } from '@asm/const';
import { Observable } from 'rxjs';

export abstract class AsmAdapter {
  /**
   * Abstract function used to search for customers.
   */
  abstract customerSearch(options: CustomerSearchOptions): Observable<CustomerSearchPage>;
}
